<template>
  <pui-hot-module-layout
    id="layout-poster"
    :theme="posterTheme"
    :appAlias="POSTER_APP_NAME"
    @loadingChange="initNotificationsReference"
    class="pui-home pui-wrapper"
  >
    <pui-header>
      <template #logo>
        <router-link :to="{ name: 'applications' }" class="logo-link poster">
          <pui-image :src="imgLogoPoster" class="logo-img" alt="POSter" />
        </router-link>
      </template>

      <pui-flex justifyContent="end" class="added-button-list-container">
        <pui-sidebar>
          <pui-sidebar-item
            v-track:click="Tracking.MENU_GO_TO_DASHBOARD"
            :text="$t('poster.header.dashboard')"
            :to="{ name: 'posterDashboard' }"
            picto="mdi-gauge"
          />
          <pui-sidebar-item
            v-track:click="Tracking.MENU_GO_TO_BATCH_CREATION"
            :text="$t('poster.header.batch_creation')"
            :to="{ name: 'posterBatchCreation' }"
            picto="mdi-magnify-plus"
          />
          <pui-badge
            :content="posterCart.length ? posterCart.length : ''"
            :bgColor="posterCart.length ? 'var(--color-error-background)' : `'initial'`"
            color="var(--color-initial)"
            offsetX="38px"
            offsetY="20px"
          >
            <pui-sidebar-item
              v-track:click="Tracking.MENU_GO_TO_CREATION"
              :text="$t('poster.header.creation')"
              :to="{ name: 'posterCreation' }"
              picto="mdi-pencil-ruler"
            />
          </pui-badge>
          <pui-sidebar-item
            v-track:click="Tracking.MENU_GO_TO_DEMANDS"
            :text="$t('poster.header.demands')"
            :to="{ name: 'posterDemands' }"
            picto="mdi-format-list-bulleted-square"
          />
          <pui-header-button
            v-permission="CommonPermissions.UploadCreate"
            @click="openImportDialog"
            picto="mdi-download"
          >
            {{ $t('poster.header.import') }}
          </pui-header-button>
          <pui-header-button-separator />
          <pui-badge
            :content="notifications.length ? notifications.length : ''"
            :bgColor="notifications.length ? 'var(--color-error-background)' : `'initial'`"
            color="var(--color-initial)"
            offsetX="38px"
            offsetY="20px"
          >
            <pui-header-button ref="notifButtonRefernce" picto="mdi-bell">
              {{ $t('poster.header.notifications') }}
            </pui-header-button>
          </pui-badge>
        </pui-sidebar>
      </pui-flex>
    </pui-header>

    <div id="pui-app-main">
      <div id="pui-app-content">
        <router-view />
      </div>
    </div>
    <pui-message-box-container>
      <pui-common-message-box
        v-for="alert in alerts"
        :key="alert.id"
        :model="alert"
        :queuedCount="queuedAlertsCount"
        @close="closeAlert"
      />
    </pui-message-box-container>

    <template v-if="notificationsReference">
      <pui-notifications
        ref="notifications"
        :customReference="notificationsReference"
        updateOnCreate
      />
    </template>

    <pui-poster-file-upload-dialog ref="fileUploadDialog" />
  </pui-hot-module-layout>
</template>

<script>
import { mapGetters } from 'vuex';

import services from '../../../core/services';
import { NotificationEvents } from '../../../platform/constants/notifications';
import { CommonPermissions } from '../../common/constants/permissions';
import puiPosterFileUploadDialog from '../components/files/PosterFileUploadDialog.vue';
import { POSTER_APP_NAME, POSTER_SERVICES_NAMESPACE } from '../constants';
import Tracking from '../constants/tracking';
import { getPosterService } from '../services';
import imgLogoPoster from '../static/img/logo-poster.svg';
import posterTheme from '../theme';

export default {
  provide: {
    dialogSelector: '#layout-poster',
  },
  components: {
    puiPosterFileUploadDialog,
  },
  data() {
    return {
      notificationsReference: null,
      // Expose tracking constants
      Tracking: Tracking,
      imgLogoPoster,
      posterTheme,
      POSTER_APP_NAME,
      CommonPermissions,
    };
  },
  computed: {
    ...mapGetters({
      alerts: 'alerts',
      queuedAlertsCount: 'queuedAlertsCount',
      notifications: 'notifications',
    }),
    posterCart: {
      get() {
        return getPosterService('cartState').get();
      },
      set(nextSignageItems) {
        getPosterService('cartState').set(nextSignageItems);
      },
    },
  },
  methods: {
    /**
     * Closes the alert message
     *
     * @param {Number} alertId - the id of the alert to close
     */
    closeAlert(alertId) {
      services.getService('alerts').clearAlert(alertId);
    },
    /**
     * Initialiezs the notifications reference
     */
    async initNotificationsReference() {
      await this.$nextTick();
      const notifButton = this.$refs.notifButtonRefernce;
      if (notifButton) {
        this.notificationsReference = notifButton.$el;
      } else {
        this.notificationsReference = null;
      }
    },
    /**
     * Opens the notifications
     *
     * @returns {void}
     */
    openNotifications() {
      this.$refs.notifications.open();
    },
    /**
     * Opens the asset import dialog
     *
     * @returns {void}
     */
    openImportDialog() {
      if (this.$refs.fileUploadDialog) {
        // Copy array
        this.$refs.fileUploadDialog.open();
      }
    },
  },
  /**
   * Initializes module
   */
  beforeCreate() {
    services.onModuleBeforeCreate(POSTER_APP_NAME, POSTER_SERVICES_NAMESPACE);
  },
  /**
   * Initializes variables on mount
   */
  mounted() {
    this.initNotificationsReference();

    services
      .getService('notifications')
      .$on(NotificationEvents.OPEN_NOTIFICATIONS, this.openNotifications);
  },
  beforeDestroy() {
    services.onModuleBeforeDestroyed(POSTER_APP_NAME, POSTER_SERVICES_NAMESPACE);

    services
      .getService('notifications')
      .$off(NotificationEvents.OPEN_NOTIFICATIONS, this.openNotifications);
  },
};
</script>
